import { message } from "antd";
import { UpdateTfsSrpYearRate } from "../../api/UpdateTfsSrpYearRate";
import { useAPIResponse } from "../global/useApiResponse";

export const useUpdateTfsSrpYearRate = async (
  tfs_srp_year_rate_id: number,
  payload: any
) => {
  await message.loading("Updating TFS SRP Year Rate..", 2);

  const response = await UpdateTfsSrpYearRate(tfs_srp_year_rate_id, payload);

  return useAPIResponse(response);
};
